import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function FacebookPixelListener() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
      console.log("📊 Meta Pixel: PageView ->", location.pathname);
    }
  }, [location.pathname]);

  return null; // no renderiza nada en pantalla
}
